import React from "react";
import { Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Tabs from "./Tabs";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    change = (e) => {
        let value = e.target.value;
        this.setState({ search: value });
    }

    render() {
        return <>
            <Helmet>
                <title>Sports Bet</title>
                
                <link rel="canonical" href="/sports" />
            </Helmet>
            <div
                transitionAppear={true}
                transitionAppearTimeout={250}
                transitionEnterTimeout={200}
                transitionLeaveTimeout={200}
                transitionName={'FadeIn'}
            >
                <Row className="mb-2 animated fadeIn">
                    <Col className="col-12" md="12">
                        <Tabs />
                    </Col>
                </Row>
            </div>
        </>
    }
}

export default Index;
